export default {
    template: `
        <div class="counter-field">
            <button class="counter-btn minus" @click="minus()">
                -
            </button>
            
            <div class="counter-input">
                {{newValue}}
            </div>
            
            <button class="counter-btn plus" @click="plus()">
                +
            </button>
        </div>    
    `,
    props: {
        value: {
            default: 0,
            type: Number
        },
        min: {
            default: 0,
            type: Number
        },
        max: {
            default: undefined,
            type: Number
        },
        step: {
            default: 1,
            type: Number
        }

    },
    data: function () {
        return {
            newValue: 0
        }

    },
    methods: {
        plus: function() {
            if(this.max == undefined || (this.newValue < this.max)) {
                this.newValue = this.newValue + this.step;
                this.$emit('input', this.newValue);
            }
        },
        minus: function() {
            if((this.newValue) > this.min) {
                this.newValue = this.newValue - this.step;
                this.$emit('input', this.newValue);
            }
        }
    },
    watch: {
        value: {
            handler: function (newVal, oldVal) {
                this.newValue = newVal;
            }
        }
    },
    created: function(props) {
        this.newValue = this.value;
    },
}
